/**
 * Builds the shared API client config with an auth header when Okta storage exists.
 */
export default function apiConfig(url, method, data) {
  let config = {};
  let accessToken;
  const oktaTokenStorageString =
    globalThis.localStorage?.getItem("okta-token-storage");

  if (oktaTokenStorageString) {
    const oktaTokenStorage = JSON.parse(oktaTokenStorageString);

    accessToken = oktaTokenStorage.accessToken?.accessToken;
  } else {
    accessToken = null;
  }
  if (accessToken) {
    config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
  } else {
    config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  if (method) {
    config.method = method;
  }

  if (url) {
    config.url = url;
  }

  if (data) {
    config.data = data;
  }
  return config;
}
